module.exports = __webpack_public_path__ + "static/media/SP.bc3bbaf3.jpg";